import SyncableModel from "../../database/SyncableModel"
import { AutoFeederPond } from "../../database"
import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"

const AutoFeederPondStoreProps = {
  ...BaseModelStoreProps,
  state: types.maybeNull(types.frozen()),
  isFeedChanged: types.maybeNull(types.boolean),
}

/**
 * Model description here for TypeScript hints.
 */
export const AutoFeederPondStoreModel = types
  .model("AutoFeederPondStore")
  .props(AutoFeederPondStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof AutoFeederPondStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      self.initModel();
      this.set('isFeedChanged', false)
    },
    async storeToServer(data, afterPushCallback = undefined) {
      return self.storeModelToServer(AutoFeederPond, data, afterPushCallback);
    },
    async store(data, afterPushCallback = undefined) {
      return this.storeToServer(data, afterPushCallback);
      // return self.storeModel(AutoFeederPond, data);
    },
    async update(model: SyncableModel, data) {
      return self.updateModel(AutoFeederPond, model, data);
    },
    async updateOffline(model: SyncableModel, data) {
      return self.updateModelOffline(AutoFeederPond, model, data);
    },
    async delete(model: SyncableModel) {
      return self.deleteModel(AutoFeederPond, model);
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type AutoFeederPondStoreType = Instance<typeof AutoFeederPondStoreModel>
export interface AutoFeederPondStore extends AutoFeederPondStoreType {}
type AutoFeederPondStoreSnapshotType = SnapshotOut<typeof AutoFeederPondStoreModel>
export interface AutoFeederPondStoreSnapshot extends AutoFeederPondStoreSnapshotType {}
export const createAutoFeederPondStoreDefaultModel = () => types.optional(AutoFeederPondStoreModel, {})
